import React, { useEffect, Fragment } from "react";
import { useState } from "react";
import {
  GET_AGENCY_CONVENIENCE_FEE_URL,
  GET_END_USER_DOCUMENT_DETAILS_URL,
} from "../../utils/APIEndpoints";
import { authHeader } from "../../utils/functions/CoreFunctions";
import API from "../../redux/actions/API";
import ApplicationForm from "./applicationForm/index";
import {
  SET_APPLICATION_PLACEHOLDERS,
  SET_BASICFORM_VALUES,
  SET_CONVENIENCE_FEE,
  SET_DOCUMENT_TYPE,
  SET_DOCUMENT_FORMAT,
  SAVE_VALUE,
  SET_VARIABLES_LIST,
  INSTRUCTION_SAVE_VALUE,
} from "../../redux/actions/ActionTypes";
import { useSelector, useDispatch } from "react-redux";
import CustomPageNotFound from "../common/CustomPageNotFound";
import EndUserHeader from "./layout/EndUserHeader";
import { Row, Col, Container } from "reactstrap";
import CustomLoader from "../common/CustomLoader";

function LandingPage(props) {
  const {
    match: {
      params: { documentURL = "" },
    },
  } = props;

  //hooks
  const state = useSelector((state) => state.ApplicationForm);
  const { needResetForm = false, step2 = {} } = state;
  const { applicationValues = [] } = step2;
  // const { elements} = applicationValues[0];
  const dispatch = useDispatch();

  //State
  const [loading, setLoading] = useState(true);
  const [validURL, setValidURL] = useState(false);
  const [documentDetails, setDocumentDetails] = useState({});
  const [element, setElement] = useState([]);
  const [webFormInstruction, setWebFormInstruction] = useState("");

  useEffect(() => {
    applicationValues.map((val) => {
      const { elements } = val;
      setElement(elements);
    });
    dispatch({
      type: SAVE_VALUE,
      payload: element,
    });
  }, [applicationValues, element]);

  //Get Document Details
  const getDocumentDetails = async () => {
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: GET_END_USER_DOCUMENT_DETAILS_URL,
        headers: authHeader(),
        params: { serviceDomainURL: documentURL },
      };
      const response = await API(options);
      const { status } = response.data;
      if (status === "Success") {
        const {
          templatePlaceHolderValue,
          serviceAmount,
          agencyServiceId,
          requiredDocuments,
          serviceDescription = "",
          serviceName = "",
          locationCodeId = "",
          paymentType = "",
          documentType = "",
          extraFee = [],
          instructions = [],
          formInstruction = "",
        } = response.data.data;

        setWebFormInstruction(formInstruction);
        setDocumentDetails({ serviceDescription, serviceName, serviceAmount });
        dispatch({
          type: SET_DOCUMENT_TYPE,
          payload: paymentType,
        });
        dispatch({
          type: SET_DOCUMENT_FORMAT,
          payload: documentType,
        });
        dispatch({
          type: INSTRUCTION_SAVE_VALUE,
          payload: JSON.parse(instructions),
        });
        dispatch({
          type: SET_VARIABLES_LIST,
          payload: JSON.parse(extraFee),
          // payload: JSON.parse(
          //   '[{"feesId":755,"labelName":"When would you like to rent the facility?","price":0.00,"feeVariableTypeId":5,"variableType":"Single Product(Multiple Choice)","formula":"[]","agencyServiceId":1099,"multipleChoiceDetails":[{"multipleChoiceId":93,"feeVariableTypeId":5,"labelName":"winter","fees":90.00,"agencyServiceId":1099,"isDeleted":false,"feesId":755},{"multipleChoiceId":94,"feeVariableTypeId":5,"labelName":"summer","fees":50.00,"agencyServiceId":1099,"isDeleted":false,"feesId":755}]}]'
          // ),
        });

        const { status = "" } = response.data.data;
        if (status === "Accepted") {
          setValidURL(true);
          if (templatePlaceHolderValue != null) {
            const replstr = templatePlaceHolderValue.replaceAll("\u0019", "");

            const placeholders = JSON.parse(replstr);
            dispatch({
              type: SET_APPLICATION_PLACEHOLDERS,
              payload: placeholders,
            });
          }
          let form = {
            ...state.step1,
            paymentAmount: parseFloat(serviceAmount).toFixed(2),
            agencyServiceId: agencyServiceId,
            locationCodeId,
            additionalDocuments:
              requiredDocuments && JSON.parse(requiredDocuments),
          };
          dispatch({
            type: SET_BASICFORM_VALUES,
            payload: form,
            stepValue: 1,
          });
          const apiOptions = {
            method: "GET",
            url: GET_AGENCY_CONVENIENCE_FEE_URL,
            headers: authHeader(),
            params: {
              locationCodeId: parseInt(locationCodeId),
              amount: serviceAmount,
            },
          };
          const feeResponse = await API(apiOptions);
          const { status: feeResRtatus } = feeResponse.data;
          if (feeResRtatus === "Success") {
            const { ServiceFeeAmount = 0 } = feeResponse.data;
            dispatch({
              type: SET_CONVENIENCE_FEE,
              payload: parseFloat(ServiceFeeAmount).toFixed(2),
            });
          }
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        console.log(data,"error")
        // Swal.fire(getAlert('error',data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Did Mount
  useEffect(() => {
    if (needResetForm || documentURL) {
      getDocumentDetails();
    }
  }, [documentURL, needResetForm]);
  return (
    <Fragment>
      {/* Header  */}
      <EndUserHeader />
      {/* Header  */}
      <div>
        <Container>
          {loading ? (
            <Row>
              <Col md={12}>
                <center>
                  {" "}
                  <CustomLoader loading={loading} />
                </center>
              </Col>
            </Row>
          ) : (
            <Fragment>
              {validURL ? (
                <ApplicationForm
                  documentDetails={documentDetails}
                  webFormInstruction={webFormInstruction}
                />
              ) : (
                <CustomPageNotFound />
              )}
            </Fragment>
          )}
        </Container>
      </div>
    </Fragment>
  );
}
export default LandingPage;
